import { Link } from "react-router-dom";
import { usePlan } from "@/contexts/PlanContext";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function TrialBanner() {
  const { isLoading, plan, isTrialActive, daysLeftInTrial } = usePlan();

  if (isLoading || !isTrialActive || plan === "pro") {
    return null;
  }

  const days = daysLeftInTrial ?? 0;
  const urgent = days <= 3;

  return (
    <div
      className={cn(
        "border-b px-4 py-2.5 text-center text-sm",
        urgent ? "" : ""
      )}
      style={
        urgent
          ? {
              borderColor: "color-mix(in srgb, var(--color-warning) 50%, transparent)",
              background: "color-mix(in srgb, var(--color-warning) 12%, transparent)",
              color: "var(--color-text-primary)",
            }
          : {
              borderColor: "var(--color-border-default)",
              background: "color-mix(in srgb, var(--color-bg-elevated) 60%, transparent)",
              color: "var(--color-text-primary)",
            }
      }
      role="status"
    >
      <span className="inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        {urgent ? (
          <span className="font-medium">Zostały {days} dni trialu PRO — korzystaj z pełnego dostępu</span>
        ) : (
          <span>
            Masz {days} dni trialu PRO — korzystaj z pełnego dostępu
          </span>
        )}
        <Button variant="secondary" size="sm" className="h-8 shrink-0" asChild>
          <Link to="/ustawienia">Przejdź na PRO</Link>
        </Button>
      </span>
    </div>
  );
}
